<template>
    <div>
        <div class="inner" v-loading="loading">
            <div class="productPageWrapper" v-if="!loading">
                <el-row class="onlyMobile">
                    <el-col>
                        <h3>O produkcie</h3>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <div is="markdown"></div>
                    </el-col>
                </el-row>
                <layout-go-to-section />
                <layout-contact />
            </div>
        </div>
    </div>
</template>
<script>
import LayoutContact from '../../components/Layout/Contact'
import { apiClass } from '../../classes/api.class'
import { htmlClass } from '../../classes/html.class'
import { mapMutations, mapState } from 'vuex'
import LayoutGoToSection from '../../components/Layout/GoToSection'
export default {
  name: 'AutopaySdkProductView',
  components: {
    LayoutGoToSection,
    LayoutContact
  },
  computed: {
    ...mapState({
      lang: state => state.sdk.lang,
      version: state => state.sdk.version
    })
  },
  data () {
    return {
      loading: true
    }
  },
  methods: {
    ...mapMutations([
      'setSdkNavigationArray',
      'setSdkCurrentDevice'
    ]),
    getHtmlFile () {
      this.loading = true
      if (!this.version || !this.lang) {
        setTimeout(() => {
          this.getHtmlFile()
        }, 100)
        return
      }
      apiClass.getSdkFile(this.version, 'doc', '', this.lang, '.html')
        .then(
          response => {
            try {
              htmlClass.prepareHtml(response)
            } catch (err) {
              console.error(err)
            }
          },
          error => {
            console.error(error)
          })
        .finally(() => {
          this.loading = false
        })
    }
  },
  watch: {
    lang: function (newValue, oldValue) {
      if (oldValue) {
        this.getHtmlFile()
      }
    }
  },
  created () {
    this.setSdkCurrentDevice('')
    this.getHtmlFile()
  }
}
</script>
<style src="../../assets/scss/Product.scss" lang="scss"></style>
